import { createElement } from 'react';
export const compose = (...functions) => (x, config) => functions.reduceRight((acc, fn) => createElement(fn, config, acc), x);
export const createWidgetWrapperElement = (WidgetComp, props) => createElement(WidgetComp, props);
